module.exports = __webpack_public_path__ + "img/sweet-bonanza.ea888c4f.png";